<template>
  <div>
    <Breadcrumbs main="Inventario" title="Editar ingreso" v-if="objectId"/>
    <Breadcrumbs main="Inventario" title="Agregar ingreso" v-else/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 v-if="objectId">Editar Ingreso</h5>
              <h5 v-else>Agregar Ingreso</h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <label>Imagen del ingreso (requerido)</label>
                  <div class="col-md-12 mb-3">
                    <vue-dropify
                            message="Arrastra una imagen o haz click aquí."
                            uploadIcon="fa fa-upload"
                            removeIcon='fa fa-trash'
                            unit="mb"
                            ref="uploadImage"
                            @upload="uploadImage"
                    ></vue-dropify>
                    <b-form-invalid-feedback :state="form.image.is_valid">{{form.image.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Cliente (requerido)</label>
                    <multiselect placeholder="Selecciona un cliente" id="client_id"
                                 label="business_name" track-by="id"
                                 deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                                 v-model="form.client.value" :options="form.client.options"
                                 @input="getWithOutTreeCategory(categoryField, form.client.value.id)"
                                 :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                      <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                      <template slot="noOptions">No hay clientes disponibles.</template>
                    </multiselect>
                    <b-form-invalid-feedback :state="form.client.is_valid">{{form.client.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Código de despacho (requerido)</label>
                    <b-form-input
                            type="text" id="code_id" placeholder="0"
                            v-model="form.code.value">
                    </b-form-input>
                    <b-form-invalid-feedback :state="form.code.is_valid">{{form.code.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label for="stock_id">Fecha de llegada (requerido)</label>
                    <div class="row">
                      <div class="col-12">
                        <date-picker type="datetime" v-model="form.date.value"
                                     :editable="false"></date-picker>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="form.date.is_valid">{{form.date.message_error}}</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label>Observaciones (opcional)</label>
                    <b-form-textarea rows="3"
                                     v-model="form.observation.value"></b-form-textarea>
                    <b-form-invalid-feedback :state="form.observation.is_valid">{{form.observation.message_error}}</b-form-invalid-feedback>
                  </div>
                </div>
              </b-form>
              <div class="col-12 mb-5" v-show="form.client.value">
                <a class=" pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.invoicereceivedproduct_set, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <div v-for="product in form.invoicereceivedproduct_set" class="row" :key="product.id.value" v-show="form.client.value" v-on:mouseenter="setLastRowSelected(product)">
                <div class="col-4 mb-3">
                  <label>Categoría (requerido)</label>
                  <multiselect placeholder="Selecciona una categoría"
                               label="name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.category.value" :options="product.category.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductByCategory(product, product.category.value.id)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.category.is_valid">{{product.category.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-4 mb-3">
                  <label>Producto (requerido)</label>
                  <multiselect placeholder="Selecciona un producto"
                               label="small_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="product.product.value" :options="product.product.options"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false"
                               @input="setProductFilter(form.invoicereceivedproduct_set, product)">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                    <template slot="noOptions">No hay elementos en esta lista.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="product.product.is_valid">{{product.product.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-3 mb-3">
                  <label>Stock (requerido)</label>
                  <b-form-input
                          type="number" min="1"
                          v-model="product.stock.value">
                  </b-form-input>
                  <a href="javascript:void(0);" class="mr-2" title="Actualizar stock" v-on:click="setProductByCategory(product, product.category.value.id, product.product.value.id)">
                    <span class="badge badge-primary mt-2" v-if="product.product.value !== ''"><i class="fa fa-refresh"></i></span>
                  </a>
                  <span class="badge badge-success mt-2" v-if="product.product.value !== ''">{{product.product.value.invoice_stock}} disponible(s)</span>
                  <b-form-invalid-feedback :state="product.stock.is_valid">{{product.stock.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-1-mb-3">
                  <button type="button" class="btn btn-danger m-t-30" v-on:click="deleteProduct(form.invoicereceivedproduct_set, product.id.value)"><i class="fa fa-times"></i></button>
                </div>
              </div>
              <div class="col-12 mb-5 mt-5" v-show="form.client.value">
                <a class="pull-right" href="javascript:void(0);" title="Apregar producto" v-on:click="addProduct(form.invoicereceivedproduct_set, productId)">
                  <span class="badge badge-success"><i class="fa fa-plus"></i> Agregar producto</span>
                </a>
              </div>
              <div class="row">
                <b-button type="button" variant="primary" @click="onSubmit" v-if="objectId">Editar ingreso</b-button>
                <b-button type="button" variant="success" @click="onSubmit" v-else>Agregar ingreso</b-button>
                <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'InventoryInvoiceList'}">Volver</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import VueDropify from 'vue-dropify';
  import Multiselect from 'vue-multiselect';
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/locale/es';
  import 'vue2-datepicker/index.css';
  import utils from '../../../utils';

  export default {
    components: {
      'vue-dropify': VueDropify,
      Multiselect,
      DatePicker
    },
    data(){
      return {
        objectId: null,
        // INTERVALO PARA QUE ACTUALICE EL CÓDIGO CADA 5 SEGUNDOS
        productId: 1,
        // FIELD PARA OBTENER LAS CATEGORÍAS
        categoryField: utils.defaultFields({_type: 'select'}),
        // PARA OBTENER EL ÚLTIMO PRODUCTO SELECCIONADO
        lastProductSelected: null,
        lastCategorySelected: null,
        lastRow: null,
        optionsDatePicker: {
          format: 'YYYY-MM-DDThh:mm'
        },
        form: {
          image: utils.defaultFields(),
          code: utils.defaultFields(),
          observation: utils.defaultFields({required: false}),
          date: utils.defaultFields(),
          invoicereceivedproduct_set: [
            {
              id: utils.defaultFields({value: 0}),
              category: utils.defaultFields({_type: 'select'}),
              // ESTOS SON NECESARIOS
              product: utils.defaultFields({_type: 'select'}),
              stock: utils.defaultFields(),
            }
          ],
          client: utils.defaultFields({
            _type: 'select',
          }),
        },
      }
    },
    async mounted () {
      this.objectId = this.$route.params.objectId;
      if(this.objectId){
        await this.loadData(this.objectId);
      }
      this.getClient(this.form.client);
    },
    methods: {
      onSubmit(evt) {
        // console.log(evt)
        evt.preventDefault();
        // AQUÍ GUARDARÉ EL JSON FINAL PARA QUE SEA ENVIADO AL POST
        let data = {};
        const is_valid = utils.generateJsonStructure(this.form, data);
        // YYYY-MM-DDThh:mm
        data['date'] = data['date'].toISOString();
        if(is_valid){
          let _formData = new FormData();
          if(!utils.isDict(data.image)){
            delete data.image;
          }
          Object.keys(data).forEach(key => _formData.append(key, data[key]));
          _formData.delete('invoicereceivedproduct_set');
          _formData.append('invoicereceivedproduct_set', JSON.stringify(data['invoicereceivedproduct_set']));
          let _type = 'agregar un ingreso';
          if(this.objectId){
            _type = 'modificar un ingreso'
          }
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de ${_type}.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              if(!this.objectId){
                const path = '/api/inventory/v1.0/invoice/';
                const headers = {'Content-Type': 'multipart/form-data'};
                await axios.post(path, _formData, {headers: headers}).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Agregado',
                    type: 'success',
                    html: `Se ha agregado el producto de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryInvoiceList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              } else {
                const path = `/api/inventory/v1.0/invoice/${this.objectId}/`;
                const headers = {'Content-Type': 'multipart/form-data'};
                await axios.patch(path, _formData, {headers: headers
                }).then(async () => {
                  // console.log(response);
                  await this.$swal({
                    title: 'Modificado',
                    type: 'success',
                    html: `Se ha modificado el ingreso de manera correcta.`,
                  }).then(() => {
                    this.$router.push({'name': 'InventoryInvoiceList'});
                  });
                }).catch(async (error) => {
                  // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                  console.log(error.response);
                  if(error.response.status === 400){
                    utils.generateBackendError(this.form, error.response.data);
                    await this.$swal({
                      title: 'Error',
                      type: 'error',
                      html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                    });
                  }
                });
              }
            }
          });
        }else{
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      uploadImage(event){
        this.$refs.uploadImage.images = [];
        this.form.image.value = event[0];
      },
      async getClient(clientField){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        await axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            clientField.options = response.data;
            // clientField.value = clientField.options.find(option => clientField.value === option.id);
          }
        });
      },
      async getWithOutTreeCategory(inputCategory, clientId, cleanInputs=true){
        const path = `/api/inventory/v1.0/category_without_tree/`;
        const config = {
          params: {
            client_id: clientId,
          }
        };
        await axios.get(path, config).then(async (response) => {
          inputCategory.options = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        if(cleanInputs) this.cleanProducts(this.form.invoicereceivedproduct_set, this.productId);
      },
      addProduct(listProducts, id){
        listProducts.push(
            {
              id: utils.defaultFields({value: id}),
              // PARA CLONAR
              category: Object.assign({}, this.categoryField),
              // ESTOS SON NECESARIOS
              product: utils.defaultFields({_type: 'select'}),
              stock: utils.defaultFields(),
            }
        );
        this.productId++;
      },
      deleteProduct(listProducts, id){
        if(listProducts.length > 1){
          // INDEX DE LA FILA A ELIMINAR
          const index = listProducts.findIndex(item => item['id'].value === id);
          // ELEMENTO A ELIMINAR
          const element = listProducts[index];
          this.form.invoicereceivedproduct_set.forEach((item) => {
            // BUSCO TODAS LAS FILAS QUE TIENEN ESA CATEGORÍA
            if(item['category']['value']['id'] === element['category']['value']['id']){
              // SI TIENEN LA MISMA CATEGORÍA, SE AGREGA COMO UNA NUEVA SELECCIÓN Y VALIDO QUE HAYA ALGO SELECCIONADO
              if(element['product']['value']){
                item['product'].options.push(
                    element['product']['value']
                );
              }
            }
          });
          listProducts.splice(index, 1);
        }else{
          this.$swal({
            type: 'error',
            title: 'No puedes eliminar este producto.',
            html: `No se puede eliminar, debido a que debes tener como mínimo 1 producto a despachar.`,
          }).then(() => {
            this.place = null;
            this.$forceUpdate();
          });
        }
      },
      setLastRowSelected(lastRow){
        this.lastCategorySelected = lastRow['category']['value'];
        this.lastProductSelected = lastRow['product']['value'];
        this.lastRow = lastRow;
      },
      setProductFilter(listProductField, selectedValue){
        // SI HABÍA UN ELEMENTO SELECCIONADO PREVIAMENTE
        if(this.lastProductSelected !== ''){
          // BUSCO TODOS LOS PRODUCTOS QUE PERTEZCAN A LA MISMA CATEGORÍA DEL ÚLTI MPRODUCTO SELECCIONADO Y LO AGREGO COMO OPCIÓN EXCEPTUANDO DEL QUE SE DESELCCIONÓ
          listProductField.forEach((item) => {
            if(item['category']['value']['id'] === this.lastRow['category']['value']['id'] && item['id']['value'] !== this.lastRow['id']['value']){
              item['product'].options.push(
                  this.lastProductSelected
              );
            }
          });
        }
        // SE BORRA EL QUE SE SELECCIONÓ AHORA
        listProductField.forEach(function (item) {
          // SI LAS CATEGORÍAS SON IGUALES Y  NO ESTAMOS HABLANDO DEL MISMO SELECT EN EL QUE SE SELECCIONÓ
          if(item['category']['value']['id'] === selectedValue['category']['value']['id'] && item['id']['value'] !== selectedValue['id']['value']){
            const index = item['product'].options.findIndex(item => item['id'] === selectedValue['product']['value']['id']);
            if(index !== -1){
              item['product'].options.splice(index, 1);
            }
          }
        });
      },
      // PARA LIMPIAR EL V-FOR DE LOS PRODUCTOS
      cleanProducts(productsField, id){
        while(productsField.length !== 0){
          productsField.splice(0, 1);
        }
        this.addProduct(productsField, id);
      },
      async setProductByCategory(productRow, categoryId, defaultValue=null){
        const path = '/api/inventory/v1.0/product/';
        const config = {
          params: {
            category: categoryId,
            status: true,
            deleted: false
          }
        };
        await axios.get(path, config).then((response) => {
          if(response.status === 200){
            // VACÍO LOS OPTIONS
            productRow.product.options = [];
            // TENGO LAS OPCIONES
            let options = response.data;
            // CUANDO SON IGUALES ES PORQ SE ACTUALIZA EL STOCK DEL PRODUCTO O NO HABÍA NINGUNO SELECCIONADO
            // GUARDO TODAS LOS PRODUCTOS SELECCIONADOS DE LA CATEGORÍA
            let selected = [];
            // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA
            for(let i = 0; i < this.form.invoicereceivedproduct_set.length; i++){
              if(this.form.invoicereceivedproduct_set[i]['category']['value']['id'] === categoryId){
                // SI SON LA MISMA CATEGORÍA
                // VALIDO QUE HAYA ALGO SELECCIONADO
                if(this.form.invoicereceivedproduct_set[i]['product']['value']){
                  if(this.form.invoicereceivedproduct_set[i]['product']['value']['id']){
                    // CUANDO ES DISTINTO A NULO ES PORQ SOLO QUIERO ACTUALIZAR
                    // VALIDO QUE LA FILA QUE QUIERO ACTUALIZAR NO SE LE QUITE EL VALOR SELECCIONADO
                    if(defaultValue === null || productRow['id']['value'] !== this.form.invoicereceivedproduct_set[i]['id']['value']){
                      selected.push(
                          this.form.invoicereceivedproduct_set[i]['product']['value']['id']
                      );
                    }
                  }
                }
              }
            }
            // PARA RECUPERAR EL VALOR SELECCIONADO APRA CUANDO CAMBIO DE CATEGORÍA
            if(this.lastProductSelected !== '' && this.lastProductSelected !== null){
              // BUSCO ALGÚN SELECT QUE TENGA LA CATEGORÍA ANTERIOR
              for(let i = 0; i < this.form.invoicereceivedproduct_set.length; i++){
                // SI SON LA MISMA CATEGORÍA
                if(this.form.invoicereceivedproduct_set[i]['category']['value']['id'] === this.lastCategorySelected['id'] && defaultValue === null){
                  // A SUS OPCIONES LE AGREGO EL ELEMENTO SELECCIONADO DE LA CATEGORÍA CAMBIADA
                  this.form.invoicereceivedproduct_set[i]['product'].options.push(
                      this.lastProductSelected
                  );
                }
              }
            }
            // RECORRO TODAS LAS OPCIONES SELECCIONADAS
            selected.forEach((item) => {
              // LA QUITO DE LAS OPCIONES SELECCIONABLES
              const index = options.findIndex(option => option['id'] === item);
              if(index !== -1){
                options.splice(index, 1);
              }
            });
            productRow.product.options = options;
            console.log(options)
            if(defaultValue !== null){
              productRow.product.value = productRow.product.options.find(item => item['id'] === defaultValue);
            }else{
              productRow.product.value = '';
            }
          }
        });
      },
      async loadData(objectId){
        let data = {};
        let responseData;
        const defaultFieldValues = {
          category: {
            _type: 'select',
          },
          product: {
            _type: 'select',
          },
          observation: {
            required: false,
          },
        };
        const path = `/api/inventory/v1.0/invoice/${objectId}/`;
        await axios.get(path).then(async (response) => {
          responseData = response.data;
          await utils.loadDataStructure(data, responseData, defaultFieldValues);
        }).catch((error) => {
          console.log(error.response);
        });
        // for(let i = 0; i < data['invoicereceivedproduct_set'].length; i++){
        //   data['invoicereceivedproduct_set'][90]
        // }
        // // PARA BUSCAR LAS CATEGORÍAS DEL CLIENTE
        // SELECCIONO AL CLIENTE
        await this.getClient(data['client']);
        await this.$set(
            this,
            'form',
            data
        );
        // AGREGO LA FOTO POR DEFECTO
        this.$refs.uploadImage.images.push(data['image'].value);
        // GENERO UN RESPALDO DE LOS CLIENTES
        let products = this.form.invoicereceivedproduct_set;
        this.form.client = utils.defaultFields({
          value: this.form.client.options.find(item => item['id'] === this.form.client['id']['value']),
          options: this.form.client.options,
          _type: 'select',
        });
        // LE ASIGNO NUEVAMENTE SUS PRODUCTOS
        this.form.invoicereceivedproduct_set = products;
        this.form.date.value = this.$moment(this.form.date.value, "dd/MM/yyyy HH:mm:ss").toDate();
        // LISTA DE LOS VALORES DE CATEGORÍAS Y PRODUCTOS QUE TIENE CADA ROW YA QUE AL SELECCIONAR UNA CATEGORÍA ÉSTA REINICIA TODOA  DEFAULT
        let categoryValues = [];
        let productValues = [];
        let productStock = [];
        // OBTENGO LOS VALORES
        for (let i = 0; i < this.form.invoicereceivedproduct_set.length; i++){
          categoryValues.push(
              this.form.invoicereceivedproduct_set[i].category.value
          );
          productValues.push(
              this.form.invoicereceivedproduct_set[i].product.value
          );
          productStock.push(
              this.form.invoicereceivedproduct_set[i].stock.value
          );
          // this.form.invoicereceivedproduct_set[i].category.value = await this.form.invoicereceivedproduct_set[i].category.options.find(item => item['id'] === this.form.invoicereceivedproduct_set[i].category.value)
        }
        await this.getWithOutTreeCategory(this.categoryField, this.form.client.value.id, false);
        // SELECCIONAR LOS PRODUCTOS
        for (let i = 0; i < this.form.invoicereceivedproduct_set.length; i++){
          // LE COLOCO LAS CATEGORÍAS A LOS PRODUCTOS
          this.form.invoicereceivedproduct_set[i].category.options = this.categoryField.options;
          // SELECCIONO EL VALOR POR DEFECTO DE LA CATEGORÍA
          this.form.invoicereceivedproduct_set[i].category.value = await this.form.invoicereceivedproduct_set[i].category.options.find(item => item['id'] === categoryValues[i]);
          // BUSCO SUS PRODUCTOS
          await this.setProductByCategory(this.form.invoicereceivedproduct_set[i], this.form.invoicereceivedproduct_set[i].category.value.id);
          // SELECCIONO EL PRODUCTO
          this.form.invoicereceivedproduct_set[i].product.value = await this.form.invoicereceivedproduct_set[i].product.options.find(item => item['id'] === productValues[i]);
          // COLOCO EL STOCK
          this.form.invoicereceivedproduct_set[i].stock.value = productStock[i];
        }
      }
    }
  }
</script>
<style>
  .mx-datepicker {
    width: 100% !important;
  }
</style>